import type { UserEnterpriseApi } from 'api-typings/users/users';
import type { UserEnterpriseModel } from './admin-user-enterprises.model';

export function transformUserEnterprise(
  userEnterprise: UserEnterpriseApi,
): UserEnterpriseModel {
  return {
    id: userEnterprise.id,
    userId: userEnterprise.user_id,
    enterpriseId: userEnterprise.enterprise_id,
    source: userEnterprise.source,
    dateAdded: userEnterprise.date_added * 1000,
  };
}
